import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { BlogListItem } from '../../shared/models/blog.models';
import { MarketingBlogCardComponent } from './marketing-blog-card.component';

@Component({
  selector: 'app-marketing-blog-related',
  standalone: true,
  imports: [MarketingBlogCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (posts.length) {
      <section class="cg-blog-related">
        <h2 class="cg-blog-related__title">Related Articles</h2>
        <div class="cg-blog-grid cg-blog-grid--compact">
          @for (post of posts; track post.slug) {
            <app-marketing-blog-card [post]="post" />
          }
        </div>
      </section>
    }
  `,
})
export class MarketingBlogRelatedComponent {
  @Input() posts: BlogListItem[] = [];
}
